module.exports = __webpack_public_path__ + "media/images/payment_methods/sofort-0634a61951dd776a32637626ca679da7.svg";